"use strict";
var $ = require("../internals/export");
var fails = require("../internals/fails");
var intersection = require("../internals/set-intersection");
var setMethodAcceptSetLike = require("../internals/set-method-accept-set-like");
var INCORRECT = !setMethodAcceptSetLike("intersection", function(result) {
  return result.size === 2 && result.has(1) && result.has(2);
}) || fails(function() {
  return String(Array.from((/* @__PURE__ */ new Set([1, 2, 3])).intersection(/* @__PURE__ */ new Set([3, 2])))) !== "3,2";
});
$({ target: "Set", proto: true, real: true, forced: INCORRECT }, {
  intersection
});
